var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-primary",
      "ok-variant": "primary",
      "cancel-variant": "outline-secondary",
      "cancel-title": _vm.$t('golf_common_back'),
      "ok-title": _vm.$t('golf_common_confirm'),
      "modal-class": "modal-primary",
      "centered": "",
      "size": "xs",
      "title": _vm.item.dataConfirm.title
    },
    on: {
      "ok": _vm.confirmDialog
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('b-card-text', [_c('div', {
    staticClass: "w-100 text-center",
    staticStyle: {
      "padding": "20px 16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.item.dataConfirm.content))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }